export const getIsDevelopment = (config?: any): boolean => {
  const apiUrl = config?.API_URL || process.env.API_URL
  const nodeEnv = config?.NODE_ENV || process.env.NODE_ENV
  return (apiUrl !== 'https://onthatass.com/api') || (nodeEnv !== 'production')
}